import React, { FC } from 'react';
import styled from '@emotion/styled';
import css from '@styled-system/css';
import shouldForwardProp from '@styled-system/should-forward-prop';
import { system } from 'styled-system';

import sx from '../../internal/styles/sx';
import { BackgroundProps, SystemModalHeaderProps } from './types';

const BackgroundContainer = styled('div')({
  position: 'relative',
  height: '60px',
  width: '100%',
});

const BackgroundTop = styled('div', { shouldForwardProp })<BackgroundProps>(
  css({
    height: '52px',
  }),
  system({
    backgroundColor: {
      property: 'backgroundColor',
      scale: 'colors',
    },
  }),
  sx
);

const BackgroundBottom = styled('div', { shouldForwardProp })<BackgroundProps>(
  css({
    bottom: '0px',
    position: 'absolute',
    width: '100%',
    height: '16px',
    borderRadius: '0 0 100% 100%',
  }),
  system({
    backgroundColor: {
      property: 'backgroundColor',
      scale: 'colors',
    },
  }),
  sx
);

const variants = {
  critical: {
    color: 'red.20',
    iconColor: 'red.50',
  },
  success: {
    color: 'green.20',
    iconColor: 'green.50',
  },
  informative: {
    color: 'blue.20',
    iconColor: 'blue.50',
  },
  warning: {
    color: 'orange.20',
    iconColor: 'orange.50',
  },
};

const SystemModalHeader: FC<SystemModalHeaderProps> = ({
  sx,
  type = 'informative',
  children,
}) => {
  const modalHeaderBackgroundColor =
    variants[type]?.color ?? variants.informative.color;

  return (
    <BackgroundContainer>
      <BackgroundTop sx={sx} backgroundColor={modalHeaderBackgroundColor} />
      <BackgroundBottom sx={sx} backgroundColor={modalHeaderBackgroundColor} />
      {children}
    </BackgroundContainer>
  );
};

export default SystemModalHeader;
